module.exports = __webpack_public_path__ + "img/cadenas.d80b0b6a.jpg";